/**
 * @param {Object} jobData
 * @constructor
 */
export function SavedJob(jobData) {
    this.addTime = Date.now();
    this.isValid = true;
    this.companyName = jobData['companyName'];
    this.jobType = jobData['jobType'];
    //locationsは配列。locationsが空の時はlocationを配列にして取得
    this.locations = jobData['locations'] ? jobData['locations'] : [jobData['location']];
    this.salary = jobData['salary'] && jobData['salaryType'] ? `${jobData['salary']} ${jobData['salaryType']}` : jobData['salary'];
    this.title = jobData['title'];
    this.uniqueId = jobData['uniqueId'];
    this.stationName = jobData['stationName'];
    this.trainList = jobData['trainList'];
    this.siteId = jobData['siteId'];
}
